const setDisplayed = (state, currentPage) => {
    // const keysArr = Object.keys(state)
    // return state[keysArr[currentPage - 1]]
    return state[currentPage - 1]
}

export { setDisplayed }